import { create } from 'zustand'
import { TripsRecord } from "../pocketbase-types"
import { Trip, TripPoint } from '../Types/Trip'

type Trips = {
    newTrip: Trip,
    fetchedTrips: Array<TripsRecord>,
    selectedPointToBeAdded: TripPoint,
    setSelectedPointToBeAdded: (p: TripPoint) => void
    upsertRoutePoints: (p: TripPoint, index?: number) => void
    deleteRoutePoints: (index: number) => void
}

export const useTripsStore = create<Trips>((set) => {
    return {
        newTrip: {
            arriveAt: new Date(),
            departAt: new Date(),
            points: [],
            status: '',
            title: '',
            maxSubscribers: 13,
            days: []
        },
        fetchedTrips: [],
        selectedPointToBeAdded: { lat: 0, lon: 0, address: '', title: '', index: -1 },
        setSelectedPointToBeAdded: (p: TripPoint) => {
            set({ selectedPointToBeAdded: p })
        },
        upsertRoutePoints: (p: TripPoint, index?: number) => {
            set((state) => {
                if (index !== undefined && index > -1) {
                    const clonedPoints = [...state.newTrip.points]
                    clonedPoints.splice(index, 1, p)
                    return {
                        newTrip: {
                            ...state.newTrip,
                            points: clonedPoints
                        }
                    }
                } else return {
                    newTrip: {
                        ...state.newTrip,
                        points: [...state.newTrip.points, p]
                    }
                }
            })
        },
        deleteRoutePoints: (index) => {
            set((state) => {
                if (index > -1) {
                    const clonedPoints = [...state.newTrip.points]
                    clonedPoints.splice(index, 1)
                    return {
                        newTrip: {
                            ...state.newTrip,
                            points: clonedPoints
                        }
                    }
                } else return state
            })
        },
    }
})